import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {EntityBusinessNatureHdrContainerModel} from '../../../../../../models/aggregates/erp/entity';
import {
  BaseApiTemplateService,
  Core2Config,
  Pagination,
} from '../../shared';
import { ApiVisa } from '../../shared/api-visa.model';
import { ApiResponseModel, BasicApiResponseModel, PagingResponseModel } from '../../shared/api-response.model';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class EntityBusinessNatureHdrService extends BaseApiTemplateService<EntityBusinessNatureHdrContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'entity-business-nature-hdrs';
    this.endpoint_path =  Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'entity-business-nature-hdrs'; 
    this.httpClient = http;
  }

  public getPublic(visa: ApiVisa): Observable<ApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.get<ApiResponseModel<any>>(
      this.apiUrl + '/public-ep',
      this.getHttpHeader(visa)
    );
  }

  public getByGuid(
    guid: string,
    visa: ApiVisa
  ): Observable<BasicApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.get<BasicApiResponseModel<any>>(
      this.apiUrl + '/backoffice-ep/' + guid,
      this.getHttpHeader(visa)
    );
  }

  public getByCriteria(
    pagination: Pagination,
    visa: ApiVisa,
    criteria?: any,
  ): Observable<PagingResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    const UrlByCriteria =
      this.apiUrl + '/backoffice-ep/query?' + pagination.getQueryKeyValues();
    return this.httpClient.get<PagingResponseModel<any>>(
      UrlByCriteria,
      this.getHttpHeader(visa)
    );
  }

  public delete(guid: string, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.delete<ApiResponseModel<any>>(
      this.apiUrl + '/backoffice-ep/' + guid,
      this.getHttpHeader(visa)
    );
  }

  public put(dtoObject: any, visa: ApiVisa): Observable<BasicApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.put<BasicApiResponseModel<any>>(
      this.apiUrl + '/backoffice-ep',
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  public post(dtoObject: any, visa: ApiVisa): Observable<ApiResponseModel<any>> {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path;
    }
    return this.httpClient.post<ApiResponseModel<any>>(
      this.apiUrl + '/backoffice-ep',
      dtoObject,
      this.getHttpHeader(visa)
    );
  }
}
